/**
 * Theme palettes and chart color palette.
 * These match the CSS variables defined in ConfigDashboard.vue so that
 * Chart.js options can read computed CSS values at runtime.
 */

export const CHART_PALETTE = [
  '#3b82f6', '#10b981', '#f59e0b', '#ef4444', '#8b5cf6',
  '#ec4899', '#06b6d4', '#84cc16', '#f97316', '#6366f1',
  '#14b8a6', '#e11d48',
]

export function readThemeColors(rootEl) {
  const el = rootEl || document.documentElement
  const cs = getComputedStyle(el)
  const read = (name, fallback) => {
    const v = cs.getPropertyValue(name).trim()
    return v || fallback
  }
  return {
    bg: read('--dash-bg', '#ffffff'),
    surface: read('--dash-surface', '#ffffff'),
    text: read('--dash-text', '#1e293b'),
    textMuted: read('--dash-text-muted', '#64748b'),
    border: read('--dash-border', '#e2e8f0'),
    accent: read('--dash-accent', '#3b82f6'),
  }
}

export function hexToRgba(hex, alpha) {
  if (!hex || typeof hex !== 'string') return `rgba(59,130,246,${alpha})`
  const h = hex.replace('#', '')
  const r = parseInt(h.slice(0, 2), 16) || 0
  const g = parseInt(h.slice(2, 4), 16) || 0
  const b = parseInt(h.slice(4, 6), 16) || 0
  return `rgba(${r},${g},${b},${alpha != null ? alpha : 1})`
}

export function pickColors(n, palette) {
  const pal = (palette && palette.length) ? palette : CHART_PALETTE
  const out = []
  for (let i = 0; i < n; i++) out.push(pal[i % pal.length])
  return out
}
